import { RefObject, useEffect, useRef } from 'react';

// Scrolls an element into view whenever it becomes the highlighted one, e.g.
// keyboard-driven navigation through a picker list.
export const useScrollIntoViewOnChange = <T extends HTMLElement>(
  isHighlighted: boolean,
  options: ScrollIntoViewOptions = { block: 'nearest' }
): RefObject<T> => {
  const ref = useRef<T>(null);
  const optionsRef = useRef(options);
  optionsRef.current = options;

  useEffect(() => {
    if (isHighlighted) ref.current?.scrollIntoView(optionsRef.current);
  }, [isHighlighted]);

  return ref;
};
